<template>
    <div :class="showmode">
        <div class="select">
            <!-- <loader :flag="loadingInformation"></loader> 4000000000000416 -->
            <div class="no-name-checkbox">
                <input type="checkbox" id="checkbox" v-model="showName">
                <label for="checkbox" v-lang.nombreNoCoincideTarjeta></label>
            </div>
            <div class="add-credit-card-form">
                <VCreditCard @change="creditInfoChanged" :className="componentClass" :trans="translations" :noCard="true" />
            </div>
        </div>
    </div>
</template>

<script>
import VCreditCard from 'v-credit-card';
import 'v-credit-card/dist/VCreditCard.css';
const translations = {
    name: {
        label: 'Nombre',
        placeholder: 'Nombre completo'
    },
    card: {
        label: 'Número de tarjeta',
        placeholder: 'Número de tarjeta'
    },
    expiration: {
        label: 'Expiration'
    },
    security: {
        label: 'Código de seguridad',
        placeholder: 'Código'
    }
};

export default {
    name: 'paymentez-profile',
    props: {
        'paymentmethod': {
            type: Object,
            required: false,
            default: null
        },
        'pmconfig': {
            type: Object,
            required: false,
            default: null
        },
        'showbutton': {
            type: Boolean,
            required: false,
            default: true
        },
        'showmode': {
            type: String,
            required: false,
            default: 'default'
        },
        'user': {
            type: Object,
            required: false,
            default: null
        }
    },
    data () {
        return {
            instance: null,
            paymentMethodConfigurationId: 0,
            loading: true,
            loadingInformation: true,
            cardData: {
                name: '',
                cardNumber: '',
                expiration: '',
                security: ''
            },
            pmDefault: 0,
            translations,
            showName: false,
            errorClass: ''
        };
    },
    mounted () {
        this.language = this.$getLang();

        console.log('mounted visanet profile', this.pmconfig);
        if (this.pmconfig) {
            console.log('mounted visanet with config', this.showmode, this.pmconfig);
        }
    },
    computed: {
        componentClass () {
            let cssClass = 'visanet-credit-card';
            if (!this.showName) {
                cssClass += ' no-name';
            }
            if (this.errorClass !== '') {
                cssClass += ' ' + this.errorClass;
            }
            return cssClass;
        }
    },
    methods: {
        onSubmit (saveConfig = true) {
            return new Promise((resolve, reject) => {
                let ok = true;
                this.errorClass = '';
                console.log('validate ', this.cardData);
                if (this.showName) {
                    if (this.cardData.name === '') {
                        ok = false;
                        this.errorClass += ' name-error';
                    }
                }
                if (!(this.cardData.cardNumber && this.cardData.cardNumber.length > 14)) {
                    ok = false;
                    this.errorClass += ' cardnumber-error';
                }
                if (this.cardData.security === '') {
                    ok = false;
                    this.errorClass += ' cvv-error';
                }
                if (this.cardData.expiration !== '' && this.cardData.expiration.indexOf('/') >= 0) {
                    let parts = this.cardData.expiration.split('/');
                    if (parts.length > 1) {
                        let month = parseInt(parts[0]);
                        let year = 2000 + parseInt(parts[1]);
                        let strdate = '' + year + month;
                        let strnowdate = '' + new Date().getFullYear() + (new Date().getMonth() + 1).toString().padStart(2, '0');
                        console.log('compare', strdate, strnowdate);
                        if (strdate < strnowdate) {
                            ok = false;
                            this.errorClass += ' expiration-error';
                        }
                    } else {
                        ok = false;
                        this.errorClass += ' expiration-error';
                    }
                } else {
                    ok = false;
                    this.errorClass += ' expiration-error';
                }
                console.log('onSubmit', ok, this.errorClass);
                if (ok) {
                    this.cardData.cardNumber = this.cardData.cardNumber.replace(/\s/gi, '');
                    let parts = this.cardData.expiration.split('/');
                    this.cardData.expiration = parts[1] + parts[0];
                    resolve(this.cardData);
                } else {
                    reject(new Error('wrong'));
                }
            });
        },
        init (config) {
        },
        onDelete (card) {
        },
        onDefaultChange (card) {
        },
        creditInfoChanged (values) {
            // console.log('Credit card fields', values);
            // {name: "", cardNumber: "3242 3423 4233 2423", expiration: "12/32", security: "2132"}
            this.cardData = values;
        }
    },
    components: {
        VCreditCard
    }
};
</script>

<style scoped>
    .add-card-form {
        position: fixed;
        background: white;
        z-index: 99999;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
    }
    .no-name-checkbox {
        padding:10px 20px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/components/VisanetPayment.vue